import { handleActions } from "redux-actions";
import { combineReducers } from "redux";
import {
  getItems,
  getItemsSuccess,
  getItemsFailure,
  getItemsIdle,
  getItem,
  getItemSuccess,
  getItemFailure,
  getItemIdle,
  addItem,
  addItemSuccess,
  addItemFailure,
  addItemIdle,
  updateItem,
  updateItemSuccess,
  updateItemFailure,
  updateItemIdle,
  deleteItem,
  deleteItemSuccess,
  deleteItemFailure,
  deleteItemIdle,
  updateObjWithNewItemSuccess,
  clearItems,
  clearItem
} from "../actions";
import { ListFieldsKeys, ListFieldsRecordType, ListFieldsType } from "src/api/config";
import { Status } from "src/modules/modules.type";
import { PayloadAction } from "@reduxjs/toolkit";

interface GetItemsRequestProps {
  count: number;
  ID: number;
  listName: ListFieldsKeys;
  nextPage?: boolean;
  merge?: boolean;
  items?: ListFieldsType[ListFieldsKeys][];
  body?: any;
  start?: boolean;
  update?: boolean;
  delete?: boolean;
}

const initialItemsState: Partial<Record<ListFieldsKeys, number[]>> = {};

const items = handleActions(
  {
    [getItems.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (action.payload && action.payload.listName && !state[action.payload.listName]) {
        return { ...state, [action.payload.listName]: [] };
      } else if (
        action.payload &&
        action.payload.listName &&
        state[action.payload.listName] &&
        !action.payload.nextPage &&
        !action.payload.merge
      ) {
        return { ...state, [action.payload.listName]: [] };
      } else {
        return state;
      }
    },
    [getItemsSuccess.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (action.payload && action.payload.listName && action.payload.items) {
        const listName = action.payload.listName;
        const currentList = state[listName] || [];
        const newItems: number[] = action.payload.items.map((item) => item.ID) || [];

        let stateItems = [];

        if (action.payload.merge) {
          if (action.payload.start) {
            stateItems = [...newItems, ...currentList];
          } else {
            stateItems = [...currentList, ...newItems];
          }
        } else {
          if (action.payload.update) {
            stateItems = [...currentList];
          } else {
            stateItems = [...newItems];
          }
        }

        if (action.payload.delete) {
          let removeID = newItems[0] || null;
          if (removeID) {
            let newDataCurrentList: any = [];
            newDataCurrentList = [...currentList.filter((item: any) => item !== removeID)];
            stateItems = [...newDataCurrentList];
          } else {
            stateItems = [...currentList];
          }
        }

        return {
          ...state,
          [listName]: stateItems,
        };
      } else {
        return state;
      }
    },
    [clearItems.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (
        action.payload &&
        action.payload.listName &&
        state[action.payload.listName]
      ) {
        return { ...state, [action.payload.listName]: [] };
      } else {
        return state
      }
    },
  },
  initialItemsState
);

const item = handleActions(
  {
    [getItem.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (!state.hasOwnProperty(action.payload.listName)) {
        return { ...state, [action.payload.listName]: {} };
      } else {
        return { ...state }
      }
    },
    [getItemSuccess.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (action.payload && action.payload.listName && action.payload.items) {
        const listName = action.payload.listName;
        const item: any = action.payload.items[0] || {};
        return {
          ...state,
          [listName]: item,
        };
      } else {
        return { ...state };
      }
    },
    [clearItem.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      return {
        ...state,
        [action.payload.listName]: {},
      };
    },
  },
  initialItemsState
);

const initialObjState: Partial<Record<ListFieldsKeys, Record<number, ListFieldsRecordType[ListFieldsKeys]>>> = {};
// Пример возможного действия после успешного обновления элемента

const obj = handleActions(
  {
    [clearItems.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (
        action.payload &&
        action.payload.listName &&
        state[action.payload.listName]
      ) {
        return { ...state, [action.payload.listName]: {} };
      } else {
        return state
      }
    },
    [getItems.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (action.payload && action.payload.listName && !state[action.payload.listName]) {
        return { ...state, [action.payload.listName]: {} };
      } else if (
        action.payload &&
        action.payload.listName &&
        state[action.payload.listName] &&
        !action.payload.nextPage &&
        !action.payload.merge
      ) {
        return { ...state, [action.payload.listName]: {} };
      } else {
        return state;
      }
    },
    [getItemsSuccess.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (action.payload && action.payload.listName && action.payload.items) {
        const newItems: number[] = action.payload.items.map((item) => item.ID) || [];
        let itemsObj: any = {};

        action.payload.items.forEach((item) => {
          itemsObj[item.ID] = item;
        });

        let stateObj: any = {};

        if (action.payload.merge || action.payload.update) {
          stateObj = { ...state[action.payload.listName], ...itemsObj };
        } else {
          stateObj = { ...itemsObj };
        }

        if (action.payload.delete) {
          let removeID = newItems[0] || null;
          if (removeID) {
            const oldStateListObj: any = { ...state[action.payload.listName] };
            const newStateListObj: any = {};
            Object.keys(oldStateListObj).map((key) => {
              if (Number(key) !== removeID) {
                newStateListObj[key] = oldStateListObj[key];
              }
            });
            stateObj = { ...newStateListObj };
          }
        }
        return {
          ...state,
          [action.payload.listName]: stateObj,
        };
      } else {
        return state;
      }
    },
    [updateObjWithNewItemSuccess.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (action.payload && action.payload.listName) {
        const newState = state;
        if (newState && newState[action.payload.listName as ListFieldsKeys]) {
          const itemId = action.payload.ID;

          const newItem = action.payload.body;

          // Обновление нового элемента в объект
          const listObject = newState[action.payload.listName];

          if (listObject) {
            listObject[itemId] = newItem;
            newState[action.payload.listName] = listObject;
          }
        }
        return newState;
      } else {
        return state;
      }
    },
  },
  initialObjState
);

const nextPage = handleActions(
  {
    [getItems.toString()]: (state, action) => {
      if (action.payload && !action.payload.nextPage && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: null,
        };
      } else {
        return state;
      }
    },
    [clearItems.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (
        action.payload &&
        action.payload.listName &&
        state[action.payload.listName]
      ) {
        return {
          ...state,
          [action.payload.listName]: null,
        };
      } else {
        return state
      }
    },
    [getItemsSuccess.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: action.payload.nextPage,
        };
      } else {
        return state;
      }
    },
  },
  {} as any
);

const count = handleActions(
  {
    [getItems.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: 0,
        };
      } else {
        return state;
      }
    },
    [clearItems.toString()]: (state, action: PayloadAction<GetItemsRequestProps>) => {
      if (
        action.payload &&
        action.payload.listName &&
        state[action.payload.listName]
      ) {
        return {
          ...state,
          [action.payload.listName]: 0,
        };
      } else {
        return state
      }
    },
    [getItemsSuccess.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: action.payload.count,
        };
      } else {
        return state;
      }
    },
  },
  {} as any
);

const elements = combineReducers({
  items,
  item,
  obj,
  count,
  nextPage,
});

const justAdded = handleActions(
  {
    [addItemSuccess.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: action.payload.ID,
        };
      } else {
        return state;
      }
    },
    [addItem.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: null,
        };
      } else {
        return state;
      }
    },
    [addItemFailure.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: null,
        };
      } else {
        return state;
      }
    },
    [addItemIdle.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: null,
        };
      } else {
        return state;
      }
    },
  },
  {} as any
);

const justUpdated = handleActions(
  {
    [updateItemSuccess.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: action.payload.ID,
        };
      } else {
        return state;
      }
    },
    [updateItem.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: null,
        };
      } else {
        return state;
      }
    },
    [updateItemFailure.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: null,
        };
      } else {
        return state;
      }
    },
    [updateItemIdle.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: null,
        };
      } else {
        return state;
      }
    },
  },
  {} as any
);

const justDeleted = handleActions(
  {
    [deleteItemSuccess.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: action.payload.ID,
        };
      } else {
        return state;
      }
    },
    [deleteItem.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: null,
        };
      } else {
        return state;
      }
    },
    [deleteItemFailure.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: null,
        };
      } else {
        return state;
      }
    },
    [deleteItemIdle.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: null,
        };
      } else {
        return state;
      }
    },
  },
  {} as any
);

const initStatus: Partial<Record<ListFieldsKeys, Status>> = {};

const getStatus = handleActions(
  {
    [getItemsSuccess.toString()]: (state: any, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "SUCCESS",
        };
      } else {
        return state;
      }
    },
    [getItems.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "LOADING",
        };
      } else {
        return state;
      }
    },
    [getItemsFailure.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "FAILURE",
        };
      } else {
        return state;
      }
    },
    [clearItems.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "IDLE_CLEAR",
        };
      } else {
        return state;
      }
    },
    [getItemsIdle.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "IDLE",
        };
      } else {
        return state;
      }
    },
  },
  initStatus
);

const getItemStatus = handleActions(
  {
    [getItemSuccess.toString()]: (state: any, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "SUCCESS",
        };
      } else {
        return state;
      }
    },
    [getItem.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "LOADING",
        };
      } else {
        return state;
      }
    },
    [getItemFailure.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "FAILURE",
        };
      } else {
        return state;
      }
    },
    [clearItem.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "IDLE_CLEAR",
        };
      } else {
        return state;
      }
    },
    [getItemIdle.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "IDLE",
        };
      } else {
        return state;
      }
    },
  },
  initStatus
);

const updateStatus = handleActions(
  {
    [updateItemSuccess.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "SUCCESS",
        };
      } else {
        return state;
      }
    },
    [updateItem.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "LOADING",
        };
      } else {
        return state;
      }
    },
    [updateItemFailure.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "FAILURE",
        };
      } else {
        return state;
      }
    },
    [updateItemIdle.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "IDLE",
        };
      } else {
        return state;
      }
    },
  },
  {} as any
);

const addStatus = handleActions(
  {
    [addItemSuccess.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "SUCCESS",
        };
      } else {
        return state;
      }
    },
    [addItem.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "LOADING",
        };
      } else {
        return state;
      }
    },
    [addItemFailure.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "FAILURE",
        };
      } else {
        return state;
      }
    },
    [addItemIdle.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "IDLE",
        };
      } else {
        return state;
      }
    },
  },
  {} as any
);

const deleteStatus = handleActions(
  {
    [deleteItemSuccess.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "SUCCESS",
        };
      } else {
        return state;
      }
    },
    [deleteItem.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "LOADING",
        };
      } else {
        return state;
      }
    },
    [deleteItemFailure.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "FAILURE",
        };
      } else {
        return state;
      }
    },
    [deleteItemIdle.toString()]: (state, action) => {
      if (action.payload && action.payload.listName) {
        return {
          ...state,
          [action.payload.listName]: "IDLE",
        };
      } else {
        return state;
      }
    },
  },
  {} as any
);

const spitems = combineReducers({
  elements,
  justAdded,
  justUpdated,
  justDeleted,
  addStatus,
  getStatus,
  updateStatus,
  deleteStatus,
  getItemStatus,
});

export { spitems };
